import {CustomAuditable} from "@/entity/CustomAuditable";

export class MerchantCircle extends CustomAuditable {

    public parent?: MerchantCircle;
    public children: MerchantCircle[] = [];

    public userId=''
    public userMessage = ''
    public userName =''
    public userCompany=''
    public imageCapture: string[]=[]
    // public createdDate?: Date;
    createdDate = ''
    // public lastLoginDate?: Date;

    public static of(o: any): MerchantCircle {
        const assign = Object.assign(new MerchantCircle(), o);
        delete assign.new;
        return assign;
    }

    public static getColumns(): QTableColumn[] {
        return [
            {name: 'label', field: 'label', label: '名称'},
            {name: 'to', field: 'to', label: '码'},
            {name: 'codeLimit', field: 'codeLimit', label: '子节点码长度限制'},
            {name: 'adminId', field: 'adminId', label: '管理员工号'},
            {name: 'shenHeId', field: 'shenHeId', label: '审核流程Id'},
            {name: 'beiZhu', field: 'beiZhu', label: '备注'},
            {name: 'parent', field: 'parent', label: '父'},
            {name: 'children', field: 'children', label: '子'},
        ];
    }

    public getColumnLabel(field: string) {
        const columns = MerchantCircle.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field,
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}